module.exports = __webpack_public_path__ + "static/assets/d2c97ed5e94c8bbf98d72d8640e0b7d7.png";